module.exports = __webpack_public_path__ + "assets/pdf/E03-en-tibetan-plateau-vortices.1fa483a8.pdf";